import { SimpleGrid } from "@mantine/core";
import { IconChevronRight } from "@tabler/icons-react";
import type { ReactNode } from "react";
import { RecordCard } from "../components/ui";
import { Page, PageNote } from "./Page";

// Re-exported: several landings import NoteText from here, and the paragraph
// style belongs with PageNote rather than with the tile grid.
export { NoteText } from "./Page";

export interface Tile {
  to: string;
  label: string;
  blurb: string;
  icon?: ReactNode;
}

/**
 * A module's landing screen: what you can do in here, and the one thing worth
 * knowing before you do it.
 *
 * Every module had this same shape written out by hand - a tile grid and an
 * explanatory card - which is five copies of one layout and five places for
 * the spacing to drift apart. The tiles and the note are the only things that
 * differ, so they are the only things a module states.
 */
export function ModuleLanding({
  title,
  subtitle,
  tiles,
  note,
  noteTitle,
}: {
  title: string;
  subtitle?: string;
  tiles: Tile[];
  /** The paragraph(s) under the tiles. Omitted where a module has nothing to add. */
  note?: ReactNode;
  noteTitle?: string;
}) {
  return (
    <Page title={title} subtitle={subtitle}>
      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">
        {tiles.map((tile) => (
          <RecordCard
            key={tile.to}
            to={tile.to}
            primary={tile.label}
            secondary={tile.blurb}
            leading={tile.icon}
            action={
              <IconChevronRight
                size={18}
                stroke={1.8}
                color="var(--mantine-color-gray-5)"
              />
            }
          />
        ))}
      </SimpleGrid>

      {note && <PageNote {...(noteTitle ? { title: noteTitle } : {})}>{note}</PageNote>}

    </Page>
  );
}
